import React from 'react';
import { Logo } from '../components/common/Logo';

const IndexPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-100">
      <div className="text-center">
        <Logo size="large" showText />
        <p className="mt-6 text-secondary-600 text-lg">
          Welcome to Faster CMS Plugin Webview
        </p>
        <p className="mt-2 text-secondary-500">
          Please use the SSO initialization route to access plugins
        </p>
      </div>
    </div>
  );
};

export default IndexPage;
